export default {
    employeesList: [],
    availableClasses: [],
    availableDepartments: [],
    numberOfResults: 1,
    courses: [],
}